import z from "zod";
import { defineObject } from "sanity-typed-queries";
import callToAction from "./callToAction.js";
export var schema = defineObject("latestNewsGridSection", {
    title: {
        title: "Title",
        type: "string",
        validation: function(Rule) {
            return Rule.required();
        }
    },
    action: {
        title: "Call to action",
        type: "callToAction"
    }
}, [
    callToAction.schema.callToAction
]);
var validator = z.object({}).partial();
schema.latestNewsGridSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=latestNewsGridSection.js.map